export const DAY_IN_MINUTES = {
  start: 0,
  end: 1440,
};
